import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class ParametroText {
  static getByNombre (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `parametro_text?r={"clave":{"nombre":"${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static updateByNombre (nombre, value) {
    const axios = getAxiosInstance()
    const promise = axios.put(`parametro_text`,
      `{"valores": {"valor": "${value}"}, "clave": {"nombre": "${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static insertParameter (nombre, descripcion, value) {
    const axios = getAxiosInstance()
    const promise = axios.post(`parametro_text`,
      `{"valores": {"nombre": "${nombre}", "descripcion": "${descripcion}", "valor": "${value}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static deleteParameter (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`parametro_text?r=` +
      `{"clave":{"nombre": "${nombre}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default ParametroText
